import { Divider, DropdownItem } from '@patternfly/react-core';
import { FunctionComponent, useCallback } from 'react';

import { signedInUser } from './SignIn';
import { apiBaseUrl } from './data/client';
import { signOut } from './data/session';
import { openPeople } from './data/open-people';

/**
 * Who is signed in, and the way out, in Kaoto's own menu.
 *
 * Renders nothing at all without a control plane, so the offline demo keeps the menu it had.
 */
export const SignedInItems: FunctionComponent = () => {
  const user = signedInUser();

  const leave = useCallback(() => {
    void signOut().finally(() => {
      // A full reload is the honest way back: every cache in the page belonged to that session.
      window.location.reload();
    });
  }, []);

  if (!apiBaseUrl() || !user) return null;

  return (
    <>
      <DropdownItem key="signed-in" isDisabled data-testid="signed-in-as">
        {user.email}
        {user.role === 'admin' ? ' · admin' : ''}
      </DropdownItem>
      {user.role === 'admin' && (
        <DropdownItem
          key="people"
          data-testid="manage-people"
          onClick={openPeople}
        >
          People
        </DropdownItem>
      )}
      <DropdownItem key="sign-out" data-testid="sign-out" onClick={leave}>
        Sign out
      </DropdownItem>
      <Divider component="li" />
    </>
  );
};
